import { render, staticRenderFns } from "./CategoryRegister.vue?vue&type=template&id=852a2030"
import script from "./CategoryRegister.vue?vue&type=script&lang=js"
export * from "./CategoryRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('852a2030')) {
      api.createRecord('852a2030', component.options)
    } else {
      api.reload('852a2030', component.options)
    }
    module.hot.accept("./CategoryRegister.vue?vue&type=template&id=852a2030", function () {
      api.rerender('852a2030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/grid/CategoryRegister.vue"
export default component.exports